import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { colors, H4, Overline, spacing } from 'ui/theme';

const Section = styled.section`
  background-color: ${colors.backgroundPrimary};
  border: solid ${spacing.single} ${colors.grey15};
  border-radius: ${spacing.fiveEights};
  width: 100%;
  padding: ${spacing.plusHalf};
  &:not(:first-child) {
    margin-top: ${spacing.double};
  }
`;

const Title = styled(H4)`
  margin-bottom: 0;
`;

const ScrollAnchor = styled.a<{ $scrollAnchorOffset: number }>`
  display: block;
  position: relative;
  height: 1px;
  top: ${({ $scrollAnchorOffset }) => `${$scrollAnchorOffset}px`};
  visibility: hidden;
`;

export const Subtitle = styled(Overline)`
  display: block;
  margin-bottom: ${spacing.plusHalf};
  color: ${colors.textSecondary};
`;

const Article = styled.article`
  margin-top: ${spacing.double};
`;

type FormSubSectionProps = {
  subtitle?: string;
};

export const FormSubSection: FC<React.PropsWithChildren<FormSubSectionProps>> = ({
  children,
  subtitle,
}) => {
  return (
    <Article>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {children}
    </Article>
  );
};

const Content = styled.div`
  margin-top: ${spacing.plusHalf};
`;

type FormSectionProps = {
  children?: ReactNode;
  id: string;
  headingText: string;
  scrollAnchorOffset?: number;
};

export const FormSection = ({
  children,
  id,
  headingText,
  scrollAnchorOffset = -175,
  ...props
}: FormSectionProps) => (
  <Section {...props}>
    <Title>{headingText}</Title>
    <ScrollAnchor id={id} $scrollAnchorOffset={scrollAnchorOffset} />
    <Content>{children}</Content>
  </Section>
);
